export const decapitalize = (value: string) => value.charAt(0).toLowerCase() + value.slice(1);
